import BrandAuditListContainer from './BrandAuditListContainer';
export default BrandAuditListContainer;
